import script from "./pedidosCompletadosTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./pedidosCompletadosTable.vue?vue&type=script&setup=true&lang=ts"

import "./pedidosCompletadosTable.vue?vue&type=style&index=0&id=0219ffbc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0219ffbc"]])

export default __exports__